function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h10v20H0V5Z",
    style: {
      fill: "#007a5e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.597 14.18 15.001 12.347 14.405 14.18 12.474 14.18 14.037 15.314 13.44 17.15 15.002 16.015 16.561 17.147 15.966 15.315 17.527 14.18 15.597 14.18",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 10,
    height: 20,
    style: {
      fill: "#fcd116"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCm);
export default __webpack_public_path__ + "static/media/CM.a0629a423ad10c5ff42321961fddb433.svg";
export { ForwardRef as ReactComponent };